<template>
  <div v-if="getStudentSummary.submission">
    <div class="flex justify-between items-center px-2 py-1 z-10 bg-white" style="height: 41px;">
      <div class="flex items-center space-x-3.5 rounded-full">
        <div :class="['flex items-center space-x-1.5 font-manrope font-semibold rounded-full py-1.5 px-1.5 text-gray-800', { 'border border-solid border-gray-200': hasTeacherPermissionsInCourse }]">
          <button
            v-if="hasTeacherPermissionsInCourse"
            @mouseenter="hovered = true"
            @mouseleave="hovered = false"
            @click="handleChangeParticipant(getStudentSummary.submission_id, 'previous')"
            class="disabled:opacity-50 bg-gray-100 hover:bg-gray-200 w-7 h-7 rounded-full flex items-center justify-center"
            :disabled="loading || orderedSubmissions.length <= 1"
          >
            <i class="fa-solid fa-angle-left"></i>
          </button>
          <div :title="studentNames ? getStudentSummary.user.name : getStudentSummary.submission.anonymous_identity.name" class="flex items-center space-x-2.5">
            <img
              :src="studentNames ? getStudentSummary.user.avatar_url : getStudentSummary.submission.anonymous_identity.avatar_url"
              class="rounded-full w-6 h-6"
            />
            <div class="flex items-center">
              <span class="text-gray-800 text-base" :class="hasTeacherPermissionsInCourse ? 'w-32 truncate' : 'pr-2'">
                {{ studentNames ? getStudentSummary.user.name : getStudentSummary.submission.anonymous_identity.name }}
              </span>
              <span v-if="getProfile.id === getStudentSummary.user.id" class="font-manrope font-semibold text-pinky">
                (Me)
              </span>
            </div>
            
          </div>
          <button
            v-if="hasTeacherPermissionsInCourse"
            @mouseenter="hovered = true"
            @mouseleave="hovered = false"
            @click="handleChangeParticipant(getStudentSummary.submission_id, 'next')"
            class="disabled:opacity-50 bg-gray-100 hover:bg-gray-200 w-7 h-7 rounded-full flex items-center justify-center"
            :disabled="loading || orderedSubmissions.length <= 1"
          >
            <i class="fa-solid fa-angle-right"></i>
          </button>
        </div>
        
      </div>
      <div class="flex items-center space-x-1">
        <div>
          <button
            v-if="isFeedbackEnable && !hasAssessments && hasTeacherPermissionsInCourse"
            class="bg-primary hover:bg-primary-dark text-white h-9 rounded-full flex items-center justify-center space-x-2 px-5 font-manrope"
            @click="handleSubmit()"
          >
            <span>Send</span>
            <i class="fa-solid fa-arrow-right"></i>
          </button>
        </div>
        <button
          class="bg-gray-100 hover:bg-primary-new_light hover:text-primary w-9 text-gray-600 h-9 text-lg rounded-full flex items-center justify-center"
          @click="$emit('backToOnlineStudentList')"
        >
          <i class="fa-solid fa-close text-base"></i>
        </button>
      </div>
    </div>
    <div class="max-height-list px-2 pb-4 mt-3">
      <div class="w-full h-full">
        <div class="flex justify-between items-center w-full space-x-2">
          <div class="bg-gray-100 rounded-lg flex items-center justify-between pl-3 pr-2 py-1.5 cursor-pointer w-full">
            <div @click="isAssessmentCollapsed = !isAssessmentCollapsed" class="flex items-center space-x-2">
              <button class="hover:bg-gray-200 hover:text-gray-800 text-gray-600 w-7 h-7 rounded-full">
                <i :class="!isAssessmentCollapsed ? 'fa-angle-down' : 'fa-angle-up'" class="fa-solid"></i>
              </button>  
              <h6 class="text-gray-800 font-manrope font-semibold">Assessment & Feedback</h6>
              <div class="font-manrope text-base">
                <div v-if="hasTeacherPermissionsInCourse && hasAssessments" class="flex items-center space-x-2 font-manrope">
                  <span class="text-green-500 text-xs">(Sent)</span>
                </div>
                <div v-else-if="hasTeacherPermissionsInCourse && hasDraftAssessment" class="flex items-center space-x-2 font-manrope">
                  <span class="text-yellow-500 text-xs">(Draft)</span>
                </div>
              </div>
            </div>
            <div class="flex items-center space-x-1">
              <button v-if="hasTeacherPermissionsInCourse && (!hasAssessments || !hasFeedback)" @click="handleGradeIndividualAssessment()" class="hover:bg-gray-200 pl-2 pr-2.5 h-8 rounded-lg text-gray-800 flex items-center space-x-3">
                <div class="flex items-center space-x-1 font-manrope">
                  <div class="w-7 h-7 overflow-hidden -ml-1">
                    <iframe src="https://lottie.host/embed/874b8bf3-ca7e-46f3-9c81-cf94974ad30b/Djg5qZsQK9.lottie" class="transform scale-150 w-full h-full"></iframe>
                  </div>
                  <span>Generate</span>
                </div>
              </button>
              <pl-menu direction="right" :menuSize="5">
                <button
                  v-if="hasTeacherPermissionsInCourse"
                  slot="menu_trigger"
                  class="select-none mr-1.5 w-7 h-7 hover:bg-gray-200 font-manrope text-gray-700 rounded-full flex justify-center items-center"
                >
                  <img src="/static/settings.svg" class="w-3.5 h-3.5"/>
                </button>
                <div class="rounded-lg mt-0.5 shadow-sm px-1 pt-0.5 pb-1 font-manrope text-sm text-gray-800 select-none" menu-content>
                  
                  <div class="flex flex-col space-y-3">
                    <div class="flex flex-col space-y-1.5">
                      <h6 class="font-manrope text-xs text-gray-500 mx-2 mt-1">Length</h6>
                      <ul>
                        <li v-for="(lengthOption, index) in lengthOptions" @click.stop="handleCheckLenghtOption(lengthOption)" :key="index"  class="px-2 py-1.5 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-2">
                          <input
                            type="checkbox"
                            class="cursor-pointer"
                            :checked="lengthOption === selectedLengthOption"
                          />
                          <span>{{ lengthOption }}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="flex items-center space-x-2 px-3">
                      <toggle-button
                        :sync="true"
                        :labels="false"
                        :height="16"
                        :width="28"
                        v-model="isCriteriaFeedbackOn"
                        @click.native.stop 
                        color="#eb2d7c"
                      />
                      <span class=" font-manrope text-gray-800">Feedback On Criteria</span>
                    </div>
                    <div class="flex flex-col space-y-1.5">
                      <div  class="flex items-center space-x-1 mx-2 mt-1">
                        <h6 class="font-manrope text-xs text-gray-500">Instructions</h6>
                      </div>
                      <li @click="handleEditInstructions()" class="px-2 py-1.5 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-3">
                        <i class="fa-regular fa-pen-to-square text-gray-800 ml-1"></i>
                        <span class="text-gray-800">Edit Instructions</span>
                      </li>
                      <ul>
                        <li
                          v-for="(instruction, index) in getProfile.instructions"
                          @click.stop="handleCheckInstruction(instruction)"
                          :key="instruction.id"
                          class="px-2 py-1 rounded-md cursor-pointer hover:bg-gray-100 flex justify-between items-center space-x-2"
                        >
                          <div class="flex items-center space-x-2 w-10/12 min-w-0">
                            <input
                              type="checkbox"
                              class="cursor-pointer flex-none"
                              :checked="instruction.id === selectedInstruction.id"
                              @change.stop="handleCheckInstruction(instruction)"
                              @click.stop
                            />
                            <span class="flex-1 truncate">
                              {{ instruction.title }}
                            </span>
                          </div>
                          <div class="text-xs">
                            <button
                              @click.stop="handleDeleteInstruction(instruction)"
                              class="w-6 h-6 rounded-full text-red-500 hover:text-red-600 hover:bg-red-100"
                              title="Delete"
                            >
                              <i class="fa-solid fa-minus"></i>
                            </button>
                          </div>
                        </li>
                        <li @click="handleOpenNewInstructionModal()" class="px-2 py-1.5 rounded-md cursor-pointer hover:bg-gray-100 flex items-center space-x-3">
                          <i class="fa-solid fa-plus text-primary ml-1"></i>
                          <span class="text-gray-800">New Instruction</span>
                        </li>
                        
                      </ul>
                    </div>
                  </div>
                </div>
              </pl-menu>
            </div>
          </div>
        </div>
        <div class="relative w-full h-full">
          <div v-if="getCurrentRT.enable_grading && isAssessmentCollapsed === true" class="flex flex-col space-y-2 mt-3 mb-4">
            <div v-for="(assessment, index) in assessments" :key="assessment.tag" class="flex flex-col px-2.5 pt-2 pb-2 bg-white border border-gray-200 rounded-lg">
              <div class="flex items-center justify-between">
                <div class="flex items-center">
                  <h6 class="flex-1 p-2 font-poppins text-gray-800">{{ assessment.title }}</h6>
                  <Popper
                    :append-to-body="true"
                    :prevent-default="true"
                    :options="{ placement: 'left-bottom', modifiers: { offset: { offset: '0,0px' } }}"
                    trigger="hover"
                  >
                    <div v-if="getAssessmentInfo(assessment)[0].description" class="popper flex flex-col space-y-2 py-3 px-4 bg-white rounded-md shadow-none border border-solid border-gray-200 w-72 cursor-pointer">
                      <div>
                        <h5 class="font-bold text-sm font-manrope text-left">{{ getAssessmentInfo(assessment)[0].title }}</h5>
                      </div>
                      <div class="text-left text-xs text-gray-600">
                        <div class="html-content font-manrope" v-html="typeof getAssessmentInfo(assessment)[0].description === 'object' ? getAssessmentInfo(assessment)[0].description.join('. ') : getAssessmentInfo(assessment)[0].description"></div>
                        <div v-for="(point) in getAssessmentInfo(assessment)[0].points_description" class="flex flex-col space-y-2">
                          <div class="flex items-center space-x-1 mb-2">
                            <div class="flex flex-col space-y-1">
                              <span class="font-semibold font-poppins text-gray-800">({{ point.value }}) Level: </span>
                              <span class="text-gray-700">{{ point.description }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button v-if="getAssessmentInfo(assessment)[0].description" class="flex items-center justify-center mr-3 cursor-pointer w-3.5 h-3.5 rounded-full text-white hover:bg-gray-700 bg-gray-400" slot="reference" ref="btnRef">
                      <i class="fa-solid fa-question" style="font-size: 7px;"></i>
                    </button>
                  </Popper>
                </div>
                <div class="flex items-center space-x-1 text-gray-600">
                  <button
                    v-if="hasTeacherPermissionsInCourse"
                    @click="handleChangeCriteriaPoint(index, 'minus')"
                    class="w-7 h-7 rounded-lg hover:bg-gray-200 flex items-center justify-center"
                    :disabled="Number(assessment.value) === 0"
                  >
                    <i class="fa-solid fa-minus text-xs"></i>
                  </button>
                  <input 
                    v-model="assessment.value" 
                    :disabled="!hasTeacherPermissionsInCourse" 
                    @change="handleChangeManualCriteriaPoint(index, $event.target.value)"
                    :class="[
                      'w-8 h-8 rounded-lg flex items-center text-center justify-center text-gray-800 border-0',
                      getColourClass(assessment.value)
                    ]"
                  />
                  <button
                    v-if="hasTeacherPermissionsInCourse"
                    @click="handleChangeCriteriaPoint(index, 'plus')"
                    class="w-7 h-7 rounded-lg hover:bg-gray-200 flex items-center justify-center"
                    :disabled="getCurrentRT.point_cap !== null ? Number(assessment.value) >= Number(getCurrentRT.point_cap) : false"
                  >
                    <i class="fa-solid fa-plus text-xs"></i>
                  </button>
                </div>
              </div>
              <div v-if="isCriteriaFeedbackOn" class="mx-2 font-manrope text-gray-800 flex flex-col">
                <textarea-autosize
                  v-if="hasTeacherPermissionsInCourse || (assessment.feedback != null && assessment.feedback.trim().length > 0)"
                  :placeholder="hasTeacherPermissionsInCourse ? 'Write specific feedback...' : 'No feedback...'"
                  v-model="assessments[index].feedback"
                  :disabled="!hasTeacherPermissionsInCourse"
                  @input="debouncedSaveAssessment"
                  class="focus-within:outline-none outline-none bg-white mb-1"
                ></textarea-autosize>
              </div>
            </div>
            <div v-if="assessments.length" class="flex items-center justify-between font-manrope pt-1.5 px-2">
              <span class="text-gray-800">Total Points</span>
              <span class="flex justify-center">
                <span class="flex justify-center items-center h-9 w-9 rounded-lg border border-solid border-gray-200">
                  {{ assessmentTotalPoints }}
                </span>
              </span>
            </div>
          </div>
          <div
            v-else-if="isAssessmentCollapsed === true && hasTeacherPermissionsInCourse && (!getCurrentRT.enable_grading || !getCurrentRT.points_settings.peer_rewards.length)"
            class="flex flex-col items-center justify-center mt-3 mb-3 p-8 font-manrope rounded-lg text-center text-gray-700"
          >
            <i class="fa-solid fa-triangle-exclamation text-3xl mb-2"></i>
            <h2 class="text-lg font-semibold mb-1">No Criteria Set</h2>
            <p class="text-sm text-gray-500 mb-5">
              You need to enable assessment criteria to continue.
            </p>
            
          </div>
        </div>
        <div class="flex flex-col space-y-3 w-full relative h-full">
          <div v-if="isAssessmentCollapsed === true" class="w-full h-full rounded-lg mt-3  transition-colors border border-solid border-gray-200 focus-within:ring-2 focus-within:ring-pinky-light ring-offset-2">
            <textarea-autosize
              v-if="hasTeacherPermissionsInCourse || hasFeedback"
              v-model="evaluation.comment"
              ref="assessment-textarea"
              
              :placeholder="`Write general feedback to ${currentUserName}, or use Genie...`"
              class="px-4 py-3 w-full h-full rounded-lg  outline-none font-manrope text-gray-800 bg-white"
              @input="debouncedSaveFeedback"
              :disabled="!hasTeacherPermissionsInCourse || getCurrentRT.is_genie_grader_running === true"
            ></textarea-autosize>
            <div v-else class="p-2.5">There is currently no feedback here...</div>
          </div>
        </div>
        <div class="mt-3">
          <div @click="isCommentsCollapsed = !isCommentsCollapsed" class="bg-gray-100 rounded-lg flex items-center space-x-3 px-3 py-2 cursor-pointer">
            <button class="hover:bg-gray-200 hover:text-gray-800 text-gray-600 w-7 h-7 rounded-full">
              <i :class="!isCommentsCollapsed ? 'fa-angle-down' : 'fa-angle-up'" class="fa-solid"></i>
            </button>
            <span class="font-semibold text-gray-800 font-manrope">
              {{ getStudentSummary.my_comments.length === 1 ? 'Comment Made' : 'Comments Made'}}
              ({{ getStudentSummary.my_comments.length }})
            </span>
            
          </div>
          <CommentSummary
            v-if="isCommentsCollapsed"
            :class="[getStudentSummary.my_comments.length ? 'mt-2 pl-2' : '']"
          />
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import debounce from 'lodash/debounce';
import { EventBus } from '../../../utils/event-bus';
import Popper from 'vue-popperjs';
import Axios from 'axios';
import CommentSummary from 'components/commentSummary/commentSummary.vue';
import VueTextarea from 'vue-textarea-autosize';
import updateUser from 'services/account/updateUser';

export default {
  components: {
    Tooltip: () => import('../../../components/Tooltip.vue'),
    CommentSummary,
    Popper,
    VueTextarea
  },
  props: {
    orderedSubmissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      assessments: [],
      evaluation: {
        grade: 0,
        comment: '',
      },
      lengthOptions: ['Concise', 'Elaborate'],
      adjustments: {
        length: 'Concise'
      },
      instructions: [],
      selectedInstruction: {},
      isCriteriaFeedbackOn: true,
      hovered: false,
      loading: false,
      isSavingAssessment: false,
      isSavingFeedback: false,
      isFeedbackEnable: false,
      isSubmiting: false,
      isGenerating: false,
      isCommentsCollapsed: true,
      isAssessmentCollapsed: true,
      isUpdated: false,
      debouncedSaveAssessment: null,
      debouncedSaveFeedback: null,
      selectedLengthOption: "Concise"
    };
  },
  computed: {
    studentNames() {
      return this.getCurrentRT.reveal_names || !this.getCurrentRT.enable_annonymous;
    },
    hasFeedback() {
      return (
        this.getStudentSummary.submission.evaluation &&
        this.getStudentSummary.submission.evaluation.auto_save === false &&
        this.getStudentSummary.submission.evaluation.comment
      );
    },
    hasAssessments() {
      return ((this.getStudentSummary.submission.assessments && this.getStudentSummary.submission.assessments.length > 0) || (this.getStudentSummary.evaluation && this.getStudentSummary.evaluation.comment));
    },
    hasDraftAssessment() {
      return (this.getStudentSummary.submission.draft_assessments.length || this.getStudentSummary.draft_evaluation !== '');
    },
    currentUserName() {
      if (this.getCurrentRT.enable_annonymous === false) {
        return this.getStudentSummary.user.name;
      }
      return this.getStudentSummary.submission.anonymous_identity.name;
    },
    currentRealUserName() {
      return this.getStudentSummary.user.name;
    },
    assessmentTotalPoints() {
      if (this.assessments.length) {
        return this.assessments.map((a) => Number(a.value)).reduce((x, y) => x + y);
      }
    },
    ...mapGetters([
      'getProfile',
      'getCurrentRT',
      'getCourseDetail',
      'getStudentSummary',
      'getStudentAssessments',
      'hasTeacherPermissionsInCourse',
    ]),
  },
  watch: {
    'getProfile': {
      handler (newValue) {
        const current = newValue.instructions.find(i => i.checked);
        this.selectedInstruction = current || {};
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleGoToSettings: function() {
      EventBus.$emit('handleTab', 'settings');
    },
    handleDeleteInstruction: async function(instruction) {
      const filtered = this.getProfile.instructions.filter(i => i.id !== instruction.id);
      try {
        const res = await updateUser(this.getProfile.id, { instructions: filtered });
        await this.$store.dispatch('setAccount', res.data);
      } catch (err) {
        console.error(err);
      }
    },
    handleChangeInstruction: async function(instruction) {
      const updatedInstructions = this.getProfile.instructions.map(ins => ({
        id: ins.id,
        title: ins.title,
        prompt: ins.prompt,
        checked: ins.id === instruction.id ? instruction.checked : ins.checked
      }));

      try {
        const response = await updateUser(this.getProfile.id, { instructions: updatedInstructions });
        this.$store.dispatch('setAccount', response.data);
      } catch (error) {
        console.error(error);
      }
    },
    handleCheckLenghtOption: function(option) {
      this.selectedLengthOption = this.selectedLengthOption === option ? "Concise" : option;
    },
    handleCheckInstruction: async function(instruction) {
      this.selectedInstruction = instruction;
      const updated = this.getProfile.instructions.map(ins => ({
        id: ins.id,
        title: ins.title,
        prompt: ins.prompt,
        checked: ins.id === instruction.id
      }));
      try {
        const res = await updateUser(this.getProfile.id, { instructions: updated });
        this.$store.dispatch('setAccount', res.data);
      } catch (err) {
        console.error(err);
      }
    },
    handleOpenNewInstructionModal: function() {
      this.$router.replace({ query: { popup: true } });
      EventBus.$emit('handleOpenInstructionsModal', true);
    },
    handleEditInstructions: function() {
      EventBus.$emit('handleOpenGenieGraderModal');
    },
    handleSetAssessments: async function() {
      const source = this.hasTeacherPermissionsInCourse ? this.getStudentSummary.submission.draft_assessments : this.getStudentAssessments;
      this.assessments = Array.isArray(source) ? source.map(a => ({ tag: a.tag, title: a.title, value: a.value, feedback: a.feedback })) : [];
      
      this.evaluation.comment = this.getStudentSummary.evaluation.comment ? this.getStudentSummary.evaluation.comment : this.getStudentSummary.draft_evaluation;
      this.isFeedbackEnable = !this.getStudentSummary.evaluation.comment && !this.getStudentSummary.submission.assessments.length;
    },
    handleSaveAssessment: async function() {
      if (!this.hasTeacherPermissionsInCourse) return;

      this.isSavingAssessment = true;

      try {
        const { peer_rewards } = this.getStudentSummary.points_settings;
        const pointCap = this.getCurrentRT.point_cap;

        const assessmentsNew = peer_rewards.map(pr => {
          const found = this.assessments.find(a => a.tag === pr.tag) || {};
          let value = Number(found.value) || 0;
          if (pointCap && value > pointCap) value = pointCap;
          return { tag: pr.tag, value, feedback: found.feedback || null };
        });

        await this.$store.dispatch('saveDraftAssessment', { submissionID: this.getStudentSummary.submission_id, assessments: { assessments: assessmentsNew } });

        if (this.hasAssessments && this.hasFeedback) {
          await this.$store.dispatch('saveAssessment', {
            submissionID: this.getStudentSummary.submission_id,
            assessments: { assessments: this.assessments },
          });
        }

      } catch (err) {
        console.error(err);
      } finally {
        this.isSavingAssessment = false;
      }
    },
    handleSaveFeedback: async function() {
      try {
        this.isSavingFeedback = true;
        const payload = {
          submissionID: this.getStudentSummary.submission_id,
          draft_evaluation: { ...this.evaluation, auto_save: false },
        };
        await this.$store.dispatch('postDraftEvaluation', payload);

        if (this.hasFeedback) {
          await this.$store.dispatch('postEvaluation', {
            submissionID: this.getStudentSummary.submission_id,
            evaluation: { ...this.evaluation, auto_save: false },
          });
        }

      } catch (error) {
        this.isSavingFeedback = false;
      }
    },
    handleSubmit: async function() {
      try {
        this.isSubmiting = true;
        const assessments = await this.$store.dispatch('saveAssessment', {
          submissionID: this.getStudentSummary.submission_id,
          assessments: { assessments: this.assessments },
        });
        const feedback = await this.$store.dispatch('postEvaluation', {
          submissionID: this.getStudentSummary.submission_id,
          evaluation: { ...this.evaluation, auto_save: false },
        });

        await Promise.all([feedback, assessments]);
        this.isSubmiting = false;

        this.isFeedbackEnable = false;
      
        EventBus.$emit('createToast', { type: 'Success', message: `Assessment and Feedback sent to ${this.currentRealUserName}`, time: 5000 });
        
      } catch (error) {
        console.error(error);
        EventBus.$emit('createToast', { type: 'Error', message: `Something happened saving the assessment, please try again`, time: 5000 });
      }
    },
    handleGradeIndividualAssessment: async function() {
      try {
        const prompt_response = this.getStudentSummary.submission.prompt_response.replace(/(<([^>]+)>)/gi, '');
        const payload = {
          roundtable_id: this.getCurrentRT.id,
          user_id: this.getProfile.id,
          prompt_summarized: this.getCurrentRT.prompt_summarize,
          criterias_roundtable: this.getCurrentRT.points_settings.peer_rewards,
          total_score: this.getCurrentRT.point_cap,
          submission: {
            id: this.getStudentSummary.submission_id,
            comments: this.getStudentSummary.my_comments,
            prompt_response: prompt_response,
            draft_assessments: this.assessments,
          },
          is_criteria_feedback_on: this.isCriteriaFeedbackOn,
          length_feedback: this.selectedLengthOption,
          custom_instruction: {
            title: this.selectedInstruction.title,
            instruction: this.selectedInstruction.prompt
          }
        };
        this.$emit('backToOnlineStudentList');
        EventBus.$emit('student_panel', false);
        await Axios.post(`/api/grader/individual/${this.getCurrentRT.id}`, payload);
      } catch (error) {
        console.error(error);
      }
    },
    handleFeedbackInput: function(index, value) {
      this.assessments[index].feedback = value;
      this.debouncedSaveAssessment();
    },
    handleChangeCriteriaPoint: function(index, type) {
      const current = Number(this.assessments[index].value) || 0;
      const newValue = type === 'plus' ? current + 1 : Math.max(0, current - 1);
      this.$set ? this.$set(this.assessments[index], 'value', newValue) : (this.assessments[index].value = newValue);
      this.debouncedSaveAssessment();
    },
    handleChangeManualCriteriaPoint: function(index, value) {
      const newValue = value;
      this.$set ? this.$set(this.assessments[index], 'value', newValue) : (this.assessments[index].value = newValue);
      this.debouncedSaveAssessment();
    },
    handleChangeParticipant: async function(submissionId, direction) {
      try {
        this.loading = true;
        this.$store.commit('UPDATE_SUBMISSION_SPREAD', {
          id: submissionId,
          opened_submission: false,
        });

        const ids = [...this.orderedSubmissions];
        const i = ids.indexOf(submissionId);
        const reordered = ids.splice(i).concat(ids);
        const nextId = direction === 'next' ? reordered[1] : reordered[reordered.length - 1];

       if (nextId) {
         EventBus.$emit('scrollToSubmission', nextId);
         await this.$store.dispatch('getSubmissionSummary', nextId);
         await this.handleSetAssessments();
       }
      } catch (e) {
        EventBus.$emit('createToast', { type: 'Error', message: 'Something happened. Please try again or refresh the page...', time: 5000 });
      } finally {
        this.loading = false;
      }
    },
    getAssessmentInfo: function (assessment) {
      const info = this.getCourseDetail.points_settings.peer_rewards.filter((reward) => reward.tag === assessment.tag);
      return info;
    },
    getColourClass(value) {
      const cap = this.getCurrentRT.point_cap;
      if (cap != null && cap > 1) {
        const colours = ['bg-red-100', 'bg-yellow-100', 'bg-green-100', 'bg-green-100'];
        const bucket = Math.min(
          colours.length,
          Math.ceil((value * (colours.length - 1)) / (cap - 1))
        );
        return colours[bucket - 1];
      }
      return 'bg-white border border-solid border-gray-200';
    },
    onEscapeKeyUp: function(e) {
      if (e.which === 27) this.$emit('backToOnlineStudentList');
    },
  },
  async mounted() {
    await this.handleSetAssessments();
    if (this.hasTeacherPermissionsInCourse) {
      this.debouncedSaveAssessment = debounce(this.handleSaveAssessment, 1000);
      this.debouncedSaveFeedback = debounce(this.handleSaveFeedback, 1000);
    }
    window.addEventListener('keyup', this.onEscapeKeyUp);
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.onEscapeKeyUp);
    if (!this.hasAssessments || !this.hasFeedback) {
      this.handleSaveAssessment();
      this.handleSaveFeedback();
    }
  },
};
</script>

<style scoped>
.max-height-list {
  max-height: calc(100vh - 130px);
  overflow-y: auto;
}
</style>
<style lang="scss" scoped>
  input[type='checkbox'] {
    width: 1.25rem !important;
    height: 1.25rem !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    box-shadow: none;
    font-size: 0.8rem;
    text-align: center;
    line-height: 1.25rem;
    border-radius: 0.25rem;
    --tw-bg-opacity: 1;
    background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  }
  input[type='checkbox']:checked {
    background-color: #72ccd7;
  }
  input[type='checkbox']:checked::after {
    font-family: 'Font Awesome 5 Free';
    content: '\f00c';
    font-weight: 900;
    color: white;
    line-height: 1.25rem;
  }
</style>



// WEBPACK FOOTER //
// onlineStudentsAssessment.vue?26453631